import { IterableElement } from 'type-fest'
import { POLYGON_TOKEN_TICKERS } from './token-tickers'

import { Ticker } from '../ticker'

export const POLYGON_TICKERS = [Ticker.POL, ...POLYGON_TOKEN_TICKERS]

export type PolygonTicker = IterableElement<typeof POLYGON_TICKERS>
